import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  Stack,
  Divider,
  Link,
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import YouTubeIcon from '@mui/icons-material/YouTube';


const Footer = () => {
  const localBranches = [
    {
      city: "Surat",
      address: `G-26, Magnus Shopping Centre, Althan Bhimrad Canal Road , Althan Surat,395017`,
      phone: "+91-88491 49900",
      email: " jananidhi.29surat@gmail.com",
    },

  ];

  const adminAddress = {
    name: "National Administrative Office",
    address: `Plot No. 1143A, Flat no A1/A3,
Ground Floor, Khodiyar Appts,
Opp. Police Ground, FC road,
Shivaji Nagar, Pune, Maharashtra.`,
    city: "Pune, Maharashtra",
    email: "contactus@nycsindia.com",
    phone: "(011)46110390/26101063"
  };

  return (
    <Box
      sx={{
        background: 'linear-gradient(to right, #1976d2, #512da8)',
        color: 'white',
        pt: 6,
        pb: 3,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={12}>
          {/* Local Branches Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Local Branches
            </Typography>
            {localBranches.map((branch, index) => (
              <Box key={index} sx={{ mb: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                  {branch.city}
                </Typography>
                <Stack spacing={1} sx={{ ml: 1, mt: 1 }}>
                  <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LocationOnIcon sx={{ fontSize: 18 }} />
                    {branch.address}
                  </Typography>
                  <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PhoneIcon sx={{ fontSize: 18 }} />
                    {branch.phone}
                  </Typography>
                  <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <EmailIcon sx={{ fontSize: 18 }} />
                    {branch.email}
                  </Typography>
                </Stack>
              </Box>
            ))}
          </Grid>

          {/* Administrative Address Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Administrative Office
            </Typography>
            <Box sx={{ ml: 1 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
                {adminAddress.name}
              </Typography>
              <Stack spacing={1}>
                <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <LocationOnIcon sx={{ fontSize: 18 }} />
                  {adminAddress.address}
                  <br />
                  {adminAddress.city}
                </Typography>
                <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <EmailIcon sx={{ fontSize: 18 }} />
                  {adminAddress.email}
                </Typography>
                <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PhoneIcon sx={{ fontSize: 18 }} />
                  {adminAddress.phone}
                </Typography>
              </Stack>
            </Box>
          </Grid>

          {/* Connect With Us Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Connect With Us
            </Typography>
            <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
              <IconButton
                href='https://www.facebook.com/NYCSIndia/?ref=br_rs'
                target='_blank'
                sx={{
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    transform: 'scale(1.1)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                href='https://www.youtube.com/channel/UCbZJ6pH6_XxFPdDT6CgUrBg'
                target='_blank'
                sx={{
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    transform: 'scale(1.1)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                <YouTubeIcon />
              </IconButton>
              <IconButton
                href='https://www.linkedin.com/in/national-yuva-cooperative-society-limited-nycs-4541b2242/'
                target='_blank'
                sx={{
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    transform: 'scale(1.1)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                href='https://www.instagram.com/nycsindia/'
                target='_blank'
                sx={{
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    transform: 'scale(1.1)'
                  },
                  transition: 'all 0.3s ease'
                }}
              >
                <InstagramIcon />
              </IconButton>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,0.1)' }} />

        {/* Copyright Section */}
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 2
        }}>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            © {new Date().getFullYear()} Nycs India. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={2}>
            <Link
              href="/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ color: 'white', opacity: 0.8 }}
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ color: 'white', opacity: 0.8 }}
            >
              Terms of Service
            </Link>
          </Stack>

        </Box>
      </Container>
    </Box>
  );
};

export default Footer;